export default __webpack_public_path__ + "static/media/naidi-3-2.a238017b.svg";